<script setup lang="ts">
  import {storeToRefs} from 'pinia';
  import {onMounted, watch, ref} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import {useCategoriesMenuStore} from '~/stores/categoriesMenuStore';
  import {useCategoriesMenu} from '~/composables/useCategoriesMenu';
  import CpNavMenuCategoryCard from '~/components/cp/CpNavMenu/CpNavMenuCategoryCard/CpNavMenuCategoryCard.vue';
  import CpNavMenuCategoriesHeader
      from '~/components/cp/CpNavMenu/CpNavMenuCategoriesHeader/CpNavMenuCategoriesHeader.vue';
  import CpNavMenuRecommendations from '~/components/cp/CpNavMenuRecommendations/CpNavMenuRecommendations.vue';

  const categoriesStore = useCategoriesMenuStore();
  const {activeCategory} = storeToRefs(categoriesStore);
  const {selectCategory} = useCategoriesMenu();
  const el = ref<HTMLElement>();

  const props = defineProps<{
      /* only used on storybook, don't use in production the data will be obtained by pinia */
      storyCategory?: string,
  }>();
  onMounted(() => {
      if (!props.storyCategory) {
          return;
      }
      selectCategory(props.storyCategory);
  });

  watch(activeCategory, () => {
    if (el.value) {
      el.value?.scrollTo({top: 0});
    }
  }, {immediate: false});

  const {b, e} = useCpBem('cp-nav-menu-categories');
</script>

<template>
    <div v-if="activeCategory?.subCategories" ref="el" :class="b" data-testid="nav-menu-categories">
        <CpNavMenuCategoriesHeader />
        <div :class="e('container')">
            <CpNavMenuCategoryCard
                v-for="cat in activeCategory.subCategories"
                :id="cat.id"
                :key="cat.id"
                :horizontal="true"
                :image="cat.image!"
                :name="cat.title"
                @onselect="id => selectCategory(id)"
            />
            <CpNavMenuRecommendations v-if="activeCategory?.linkGroups?.length > 0" :link-groups="activeCategory?.linkGroups!" />
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-categories {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 100px;
    overflow: auto;

    &__container {
      display: flex;
      flex-direction: column;
      //min-height: 100px;
      padding: $cp-gutter;
      //overflow: auto;
      //height: 100%;
      flex: 1;
    }
  }
</style>
